/**
 * Catalog config keys read on the eager boot path: the global books config (`core/global-config`)
 * and the catalog view's global-config selectors resolve these before the catalog feature loads.
 *
 * Kept in an import-free leaf module: anything this file imports ships in the eager `app` bundle
 * alongside it, and the remaining catalog config keys plus the category-name resource map in
 * `./constants.ts` are read only from lazily-loaded chunks.
 */

export const BOOK_SUPPORT_ENABLED_FEATURE_FLAG_NAME = 'features.book_support.enabled';
export const BOOKS_DISABLED_FOR_LIBRARIES = 'features.library.books.disabled';
export const CATALOG_BOOKS_JUST_ADDED = 'app.views.catalog.books.just_added.enabled';
export const FEATURED_CATALOG_CAROUSEL_ISSUES_ENABLED = 'features.catalog.carousel.issues.enabled';
